module.exports = __webpack_public_path__ + "static/media/content-image-3.a6150dfe.png";